import type { CookieRef } from '#app'

export const useConfirmCountry = () => {
  const confirmCountryCookie: CookieRef<boolean | undefined> = useCookie(
    'show_confirm_country'
  )

  const localState = useState<boolean>('local-state', () => false)

  onMounted(async () => {
    if (
      typeof confirmCountryCookie.value === 'undefined' ||
      confirmCountryCookie.value
    ) {
      // Get current site country from route
      const { country: siteCountry } = useRouteHelper()

      // Check if user is in the same country as the site
      try {
        const geoResponse = await $fetch<{
          geo?: { country?: { code?: string } }
        }>('/api/geolocation')
        const userCountryCode = geoResponse?.geo?.country?.code?.toLowerCase()
        const siteCountryCode = siteCountry?.toLowerCase()

        // Don't show banner if user is in the same country as the site
        // Set cookie to false so it doesn't check again this session
        if (
          userCountryCode &&
          siteCountryCode &&
          userCountryCode === siteCountryCode
        ) {
          confirmCountryCookie.value = false
          localState.value = false
          return
        }
      } catch (error) {
        // If geo fetch fails, proceed with original logic
        console.warn('Failed to fetch geolocation:', error)
      }
      await nextTick()
      localState.value = true
      confirmCountryCookie.value = false
    }
  })

  const open = () => {
    confirmCountryCookie.value = true
    localState.value = true
  }

  const disable = () => {
    if (typeof confirmCountryCookie.value === 'boolean') {
      confirmCountryCookie.value = false
      localState.value = false
    }
  }

  const isOpen = computed(() => localState.value)

  return {
    isOpen,
    disable,
    open,
  }
}
